<script setup lang="ts">
import IconSprite from '@/uiKit/IconSprite.vue'

defineProps<{
  showBadge?: boolean
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <div class="absolute bottom-2 right-2">
    <div
      v-if="showBadge"
      class="absolute right-px top-px size-1.5 rounded-full bg-icon-warning"
    />
    <button
      class="flex size-7 cursor-pointer items-center justify-center rounded-full bg-surface-primary p-1.5 text-icon-subtle shadow-xs hover:bg-surface-secondary active:bg-surface-tertiary"
      @click="emit('click')"
    >
      <IconSprite
        icon="question-mark"
        class="size-4"
      />
    </button>
  </div>
</template>
